import axios from 'axios';
// config
import { SERVER_API } from '../config';

let backendURL = localStorage.getItem('backendURL');

// ----------------------------------------------------------------------

// console.log("[axios] backendURL: ", localStorage.getItem('backendURL'));

//! pas besoin de set l'authorization ici avec le token car c'est deja fait au moment du setSession, dans l'init de l'Oauth (voir utils.js)

const axiosInstance = axios.create({
  baseURL: backendURL
});

axiosInstance.interceptors.response.use(function (response) {
  return response;
  }, function (error) {
    return Promise.reject(error)
  });

export default axiosInstance;